<script setup>

import {getPropertyName} from "@/helper.js";
import {computed, ref} from "vue";
import Card from "@/Components/Card.vue";
import {Link, router, usePage} from "@inertiajs/vue3";
import Badge from "@/Components/Badge.vue";
import PaginateItems from "@/Components/PaginateItems.vue";
import {route} from "ziggy-js";

const page = usePage(),
    lots = ref(page.props.lots.data),
    currentPage = ref(1),
    isLoading = ref(false)

const getQueryParams = (nextPage = false) => {
    return {
        lots_page: (nextPage && currentPage.value) ? currentPage.value : undefined
    }
}
const fetch = (nextPage = false) => {
    if (!nextPage) {
        currentPage.value = 1
    }
    isLoading.value = true
    const queryParams = getQueryParams(nextPage)
    router.get(page.url, queryParams,
        {
            preserveState: true,
            preserveScroll: true,
            only: ['lots'],
            onFinish: () => {
                if (nextPage) {
                    lots.value = [...lots.value, ...page.props.lots.data]
                } else {
                    lots.value = page.props.lots.data
                }
                isLoading.value = false
            }
        })
}

const hasMore = computed(() => {
    return currentPage.value < page.props.lots.last_page
})
const onShowMore = () => {
    currentPage.value++
    fetch(true)
}

</script>

<template>
    <PaginateItems v-if="lots.length > 0" :has-more="hasMore"
                   :loading="isLoading" :on-show-more="onShowMore"
                   class="gap-2.5"
    >
        <template v-for="lot in lots">
            <Card class="flex flex-col">
                <div class="flex py-1.5 px-2.5 gap-2.5">
                    <div class="border border-gray-400 rounded-full shrink-0">
                        <img class="rounded-full" :src="lot.product.image_url" :alt="lot.product.title" style="width: 34px; height: 34px">
                    </div>
                    <div class="w-full">
                        <div
                            class="px-1 py-0.5 dark:text-slate-200 text-sm font-medium tracking-wide font-condensed leading-full">
                            {{ lot.product.title }}
                        </div>
                        <div
                            class="px-1 py-0.5 dark:text-slate-200 text-sm font-normal tracking-wide font-condensed leading-full border-b border-dashed w-full">
                            {{ lot.title }}
                        </div>
                    </div>
                </div>
                <template v-for="offer in lot.offers">
                    <Link class="hover:bg-slate-100 dark:hover:bg-gray-900 transition-all" :href="route('offers.show', offer)">
                        <div class="py-3"
                             :class="{'border-b border-dashed': offer !== lot.offers[lot.offers.length - 1]}">
                            <div class="flex justify-between px-2.5 py-1.5 ">
                                <div class="text-sm dark:text-slate-200 font-normal leading-120 tracking-wider">
                                    {{ offer.title }}
                                </div>
                                <div>
                                    <div class="flex gap-1 leading-full items-end">
                                        <span
                                            class="text-sm font-medium tracking-wider leading-full font-condensed">{{
                                                offer.price_currency_formatted
                                            }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="px-2.5 pb-1.5">
                                <div class="flex gap-x-1 gap-y-0.75">
                                    <template v-for="properties in offer.offer_properties">
                                        <Badge :content-classes="['h-4', 'cursor-pointer']" type="info2xl"
                                               :value="getPropertyName(properties)">
                                        </Badge>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </Link>
                </template>
            </Card>
        </template>
    </PaginateItems>

</template>

<style scoped>

</style>
